<template>
  <b-container fluid class="perks">
    <!-- NAVBAR -->
    <b-row>
      <b-col class="header-nav-bar">
        <HeaderNavBar active-link="perks" />
      </b-col>
    </b-row>

    <!-- PERKS CONTENT -->
    <b-row class="body-padding">
      <b-col class="content">
        <b-container style="margin-right: 0rem; margin-left: 0rem; ">
          <b-row align-v="center" class="perks-showcase-section">
            <!-- <PremiumContent :customerInfo="customerInfo" /> -->

            <!-- SECTION - PERKS SHOWCASE -->
            <h1 class="text-center mt-2 mb-4">See your perks</h1>

            <ProductCard :customerInfo="customerInfo"/>

          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import HeaderNavBar from "@/components/private/my-account/HeaderNavBar.vue";
import ProductCard from "@/components/private/perks/ProductCard.vue";

export default {
  title: "Dropsmart - Perks",
  name: "Perks",
  props: {
    page: {
      default: "",
      type: String,
    },
  },
  mixins: [validationMixin],

  components: {
    HeaderNavBar,
    ProductCard,
  },

  mounted() {
    this.customerInfo = JSON.parse(sessionStorage.getItem("customerInfo"));
    console.log(this.customerInfo.user.plan);
    let target = this.page ? this.page : "Perks";
    console.log("navigating to " + target);
    this.navigate(target);
  },
  data() {
    return {
      customerInfo: null,
      form: {
        emails: "",
        customerName: JSON.parse(sessionStorage.getItem("customerInfo")).user
          .firstName,
      },
      status: false,
      showLoad: false,
      EmailWasSentMessage:
        "We'll send a email inviting your friends to become part of Dropsmart.",
      EmailWasntSentMessage:
        "Sorry, but we were unable to send your message now. Please, try again later.",
    };
  },
  computed: {
  },
  methods: {
    navigate(routeName) {
      this.content = routeName;
    },
  },
};
</script>

<style scoped lang="scss">
.perks {
  .body-padding {
    padding-top: 100px;

    .content {
      padding: 0 12rem;

      .perks-showcase-section {
        display: block;

        h1 {
          font-size: 30px;
          font-weight: 700;
        }

        .card {
          border: none;
          border-radius: 0.9rem;
          margin-bottom: 2rem;

          img {
            max-height: 60px;
            margin-bottom: 1rem;
          }

          .card-text {
            span {
              font-size: 22px;
              font-weight: 700;
            }
          }

          .input-section {
            margin-bottom: 30px;

            .link-input {
              border: none;
              background-color: #ffffff;
            }
          }
        }
      }
    }
  }
}

.text-color-light {
  font-size: 0.9rem;
  color: #999999;
}

.card-link {
  svg {
    fill: #999999;
  }
  &:hover {
    color: #ee4586;
    svg {
      fill: #ee4586;
    }
  }
}

.section-title {
  font-size: 18px;
  font-weight: 700;
}

.drop-margin {
  margin-top: 2rem;
  margin-bottom: 0;
}

#textarea-email-state {
  resize: none;
  border-radius: 0.5rem;
}

hr {
  margin: 2rem 0;
}

.checkbox-section {
  margin: 2rem 0;
}

.form-checkbox {
  background-color: #9b59b6;
}

#checkbox-1 {
  accent-color: #28a745;
}

.email-form {
  max-width: 100%;
}

.toast-container-message {
  display: flex;
  justify-content: center;
  margin-bottom: 0.5rem;

  #emailsSent.toast,
  #emailsNotSent.toast {
    margin: 2rem 0;
  }
}

.button-emails-form {
  background: #79b867;
  color: #ffffff;
  border: none;
  border-radius: 30px;
  width: 30%;
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 15px;
  line-height: 25px;
}

.button-emails-form:hover {
  background: #000000;
}

.button-emails-form:active,
.button-emails-form:focus {
  background: #000000;
  color: #ffffff;
  border-color: #000000;
  box-shadow: none;
  outline: none;
}

.button-emails-form:disabled {
  background-color: #999999;
  border: 1px solid #999999;
  color: white;
}

@media screen and (max-width: 600px) {
  .perks {
    .body-padding {
      padding-top: 200px;
      .content {
        padding: 0;
      }
    }
  }
}
</style>
